/* eslint-disable perfectionist/sort-objects */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useContext, useEffect, useState } from 'react'

import { COLUMN_NAMES } from '../../assets/ts/data/dueout/dueout'
import { COLUMN_NAMES as INQUIRY_COLUMN_NAMES } from '../../assets/ts/data/inquiry/inquiry'
import { MetadataContext } from '../../store/metadata-context-provider'
import {
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  DROP_DOWN_TITLES,
  INQUIRY_AND_DUEOUT_FILTERS,
  INQUIRY_PAGES,
  NONE_SELECT_OPTION,
  NONE_SELECT_OPTION_STRING,
} from '../../utils/constants/global-constants'
import { PersonDetails } from '../../utils/constants/global-interfaces'
import CustomSelect from '../../utils/controls/custom-select'
import InputSearch from '../../utils/controls/input-search'
import {
  Closed,
  DueOutPRP,
  DueOutPriority,
  ResolvedClosed,
  Submitted,
} from '../../utils/controls/select-options-data'
import Buttons from '../buttons/buttons'

type PageType =
  | 'Archived/Dueouts'
  | 'Archived/Inquiries'
  | 'Completed/Dueouts'
  | 'Completed/Inquiries'
  | 'Dueouts'
  | 'Inquiries'
  | 'MyInquiries/Dueouts'
  | 'MyInquiries/Inquiries'
type FilterName = string
interface SelectOption {
  label: string
  value: null | number | string
}
interface Props {
  availableFilterValues: Map<string, PersonDetails[] | number[] | string[]>
  filter: any
  getSearch?: any
  hasNoData?: boolean
  onClearAll: () => void
  onUpdateFilter: (updatedArgs: any, order?: number) => void
  pageType: PageType
  resetFilters?: boolean
  tab?: string
}
interface FilterDropdown {
  AssignedComponentCode?: SelectOption[]
  AssignedUser?: SelectOption[]
  CategoryCode?: SelectOption[]
  CurrentlyServicingBy?: SelectOption[]
  FY?: SelectOption[]
  Installation?: SelectOption[]
  Organization?: SelectOption[]
  SectionCode?: SelectOption[]
  ServicingBy?: SelectOption[]
  ServicingMAJCOMCode?: SelectOption[]
  ServicingOrganization?: SelectOption[]
  SubCategoryCode?: SelectOption[]
}
let filterChanged = 0

const Filters = ({
  availableFilterValues,
  filter,
  getSearch,
  hasNoData,
  onClearAll,
  onUpdateFilter,
  pageType,
  tab,
  resetFilters,
}: Props) => {
  const metadataContext = useContext(MetadataContext)
  const [dropdownOptions, setDropdownOptions] = useState<FilterDropdown>({})
  const filterOrder = {
    FY: 1,
    AssignedComponentCode: 2,
    ServicingMAJCOMCode: 3,
    ServicingBy: 4,
    CurrentlyServicingBy: 4,
    ServicingOrganization: 5,
    Installation: 6,
    Organization: 7,
    SectionCode: 8,
    CategoryCode: 9,
    SubCategoryCode: 10,
    NotCascading: 100,
  }
  const displayFilter = (pageType: PageType, filterName: FilterName): boolean => {
    const filters = INQUIRY_AND_DUEOUT_FILTERS[pageType]
    return filters ? filters.includes(filterName) : false
  }
  const filterValues = (name) => {
    return availableFilterValues?.get(name) ?? []
  }

  const filterChangedOrder = (e, selectorder: number) => {
    filterChanged = selectorder
  }
  const generateCodeOptionOnLength = (
    metadataOptions: SelectOption[],
    codes: (null | number)[]
  ) => {
    const options = metadataOptions.filter((option) => codes.includes(option.value as number))
    if (codes.includes(null)) {
      options.unshift({ label: '(Empty)', value: null })
    }
    return options.length === 0 || hasNoData
      ? [NONE_SELECT_OPTION]
      : options.length === 1
      ? options
      : [ALL_SELECT_OPTION, ...options]
  }

  const createCodeOptions = (
    filterChanged: number,
    threshold: number,
    dropdownOptions: SelectOption[],
    metadataOptions: SelectOption[],
    codes: number[]
  ) => {
    return filterChanged >= threshold
      ? dropdownOptions
      : generateCodeOptionOnLength(metadataOptions, codes)
  }
  const generateStringOptionOnLength = (values: string[]) => {
    const options = values.map((value) => ({
      label: value,
      value: value,
    }))
    if (options.length === 0) {
      return [NONE_SELECT_OPTION_STRING]
    }
    if (hasNoData || (filterChanged === 0 && options.length === 0)) {
      return [NONE_SELECT_OPTION]
    }
    if (options.length === 1) {
      return options
    }
    if (options.length > 1) {
      return [ALL_SELECT_OPTION_STRING, ...options]
    }
  }

  const createStringOptions = (
    filterChanged: number,
    threshold: number,
    dropdownOptions: SelectOption[],
    values: string[]
  ) => {
    if (filterChanged >= threshold && !hasNoData) {
      return dropdownOptions
    }
    return generateStringOptionOnLength(values)
  }

  useEffect(() => {
    filterChanged = 0
  }, [resetFilters, hasNoData])

  useEffect(() => {
    if (filterChanged >= 0 || hasNoData) {
      const yearFilter: SelectOption[] = filterValues(COLUMN_NAMES.FY).map((v) => ({
        label: v,
        value: v,
      }))
      const yearOptions =
        hasNoData || (filterChanged === 0 && yearFilter.length === 0)
          ? [NONE_SELECT_OPTION]
          : filterChanged === 0
          ? [ALL_SELECT_OPTION, ...yearFilter]
          : dropdownOptions.FY
      const componentCodes = filterValues(COLUMN_NAMES.AssignedComponentCode) as number[]
      const componentOptions = createCodeOptions(
        filterChanged,
        filterOrder.AssignedComponentCode,
        dropdownOptions.AssignedComponentCode as SelectOption[],
        metadataContext.componentOptions,
        componentCodes
      )
      // note : currently we dont have erd update for the majcomcode
      // so it works in a different way then other filters for inquires
      const majcomCodes = filterValues(COLUMN_NAMES.ServicingMAJCOMCode) as number[]
      const majcomOptions = createCodeOptions(
        filterChanged,
        filterOrder.ServicingMAJCOMCode,
        dropdownOptions.ServicingMAJCOMCode as SelectOption[],
        metadataContext.majcomOptions,
        majcomCodes
      )
      const servicingByValues = filterValues(COLUMN_NAMES.ServicingBy) as string[]
      const servicingByOptions = createStringOptions(
        filterChanged,
        filterOrder.ServicingBy,
        dropdownOptions.ServicingBy as SelectOption[],
        servicingByValues
      )
      const currentlyServicingByValues = filterValues(
        INQUIRY_COLUMN_NAMES.CurrentlyServicingBy
      ) as string[]
      const currentlyServicingByOptions = createStringOptions(
        filterChanged,
        filterOrder.CurrentlyServicingBy,
        dropdownOptions.CurrentlyServicingBy as SelectOption[],
        currentlyServicingByValues
      )

      const servicingOrganizationValues = filterValues(
        COLUMN_NAMES.ServicingOrganization
      ) as string[]
      const servicingOrganizationOptions = createStringOptions(
        filterChanged,
        filterOrder.ServicingOrganization,
        dropdownOptions.ServicingOrganization as SelectOption[],
        servicingOrganizationValues
      )
      const sectionCodes = filterValues(COLUMN_NAMES.SectionCode) as number[]
      const sectionOptions = createCodeOptions(
        filterChanged,
        filterOrder.SectionCode,
        dropdownOptions.SectionCode as SelectOption[],
        metadataContext.sectionOptions,
        sectionCodes
      )
      const categoryCodes = filterValues(COLUMN_NAMES.CategoryCode) as number[]
      const categoryOptions = createCodeOptions(
        filterChanged,
        filterOrder.CategoryCode,
        dropdownOptions.CategoryCode as SelectOption[],
        metadataContext.categoryOptions,
        categoryCodes
      )

      const subCategoryCodes = filterValues(COLUMN_NAMES.SubCategoryCode) as number[]
      const subCategoryOptions = createCodeOptions(
        filterChanged,
        filterOrder.SubCategoryCode,
        dropdownOptions.SubCategoryCode as SelectOption[],
        metadataContext.subcategoriesOptions,
        subCategoryCodes
      )
      const assignedLocationValue = filterValues(COLUMN_NAMES.Installation) as string[]
      const assignedLocationOptions = createStringOptions(
        filterChanged,
        filterOrder.Installation,
        dropdownOptions.Installation as SelectOption[],
        assignedLocationValue
      )

      const organizationValue = filterValues(COLUMN_NAMES.Organization) as string[]
      const organizationOptions = createStringOptions(
        filterChanged,
        filterOrder.Organization,
        dropdownOptions.Organization as SelectOption[],
        organizationValue
      )
      const assignedUsersValue = filterValues(COLUMN_NAMES.AssignedTo).filter(
        (user) => user !== null
      ) as PersonDetails[]

      const assignedUsersOptions: SelectOption[] =
        filterChanged === 0
          ? [
              { label: 'Select user', value: '' },
              ...assignedUsersValue
                .sort((itemA, itemB) =>
                  itemA.properties.defaultDisplay.localeCompare(itemB.properties.defaultDisplay)
                )
                .map((item) => ({
                  label: item.properties.defaultDisplay,
                  value: item.userID,
                })),
            ]
          : (dropdownOptions.AssignedUser as SelectOption[])

      setDropdownOptions((prev) => ({
        ...prev,
        FY: yearOptions as SelectOption[],
        AssignedComponentCode: componentOptions as SelectOption[],
        ServicingMAJCOMCode: majcomOptions as SelectOption[],
        SectionCode: sectionOptions as SelectOption[],
        CurrentlyServicingBy: currentlyServicingByOptions as SelectOption[],
        CategoryCode: categoryOptions as SelectOption[],
        SubCategoryCode: subCategoryOptions as SelectOption[],
        ServicingBy: servicingByOptions as SelectOption[],
        ServicingOrganization: servicingOrganizationOptions as SelectOption[],
        Installation: assignedLocationOptions,
        Organization: organizationOptions,
        AssignedUser: assignedUsersOptions,
      }))
    }
  }, [availableFilterValues, filterChanged, hasNoData])

  const rnltdOptions = [
    { label: 'All', value: '' },
    ...(metadataContext.rnltdMetadata?.map((item) => ({
      label: `Next ${item.IntervalDuration} days`,
      value: `Next ${item.IntervalDuration} days`,
    })) ?? []),
  ]
  return (
    <>
      <div className='d-flex px-2 py-2'>
        <div className='d-flex align-items-center w-100  text-nowrap'>
          <h3
            aria-label='Filter by'
            className='m-0 me-2 title-color17 poppins-bold font-14'
            tabIndex={0}
          >
            {' '}
            <span className='icon-filter font-14 title-color17'></span> Filter by
          </h3>
          <div className='ms-auto d-flex align-items-center'>
            <div className='d-flex flex-sm-column flex-xl-row align-items-sm-start align-items-xl-center me-2'>
              {pageType !== 'Archived/Inquiries' && pageType !== 'Archived/Dueouts' && (
                <CustomSelect
                  className='form-sm w-100 max-w-sm-80 min-w-sm-80 sourcesanspro font-13 customselect'
                  formClassName='form-horizontal  poppins-semibold font-12 title-color'
                  id='year'
                  inputProps={{
                    className: 'font-12 poppins-medium title-color',
                  }}
                  label='Year'
                  name='Year'
                  onChange={(e) => {
                    onUpdateFilter(
                      {
                        yearFilter: e.value,
                      },
                      filterOrder.FY
                    )
                    filterChangedOrder(e, filterOrder.FY)
                  }}
                  options={dropdownOptions.FY}
                  value={
                    dropdownOptions.FY?.length === 2
                      ? dropdownOptions.FY[1].value
                      : filter.yearFilter
                  }
                />
              )}
            </div>
            <Buttons
              className='ms-auto btn-sm d-flex align-items-center links links-over-underline'
              label='Clear All'
              onClick={() => {
                onClearAll()
                filterChanged = 0
              }}
              type='button'
            />
          </div>
        </div>
      </div>

      <div className='row d-flex flex-wrap  p-2 pt-0'>
        {displayFilter(pageType, DROP_DOWN_TITLES.Search) && (
          <InputSearch
            className='border w-100 border-radius title-color18 sourcesanspro font-13 form-sm'
            formClassName='col-sm-12  mt-1'
            icon='icon-search px-2'
            inputProps={{
              arialabel: 'search',
              label: 'true',
              placeholder: `${DROP_DOWN_TITLES.Search}`,
              value: `${filter.searchFilter}`,
            }}
            label=''
            onChange={(e) => getSearch(e, tab)}
            searchgroup=' w-100 d-flex align-items-center inputswithicon'
            value={filter.searchFilter}
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.AssignedComponent) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='AssignComponent'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.AssignedComponent}
            name={DROP_DOWN_TITLES.AssignedComponent}
            onChange={(e) => {
              onUpdateFilter(
                {
                  assignedComponentCodeFilter: e.value,
                },
                filterOrder.AssignedComponentCode
              )
              filterChangedOrder(e, filterOrder.AssignedComponentCode)
            }}
            options={dropdownOptions.AssignedComponentCode}
            value={
              dropdownOptions.AssignedComponentCode?.length === 1
                ? dropdownOptions.AssignedComponentCode[0].value
                : filter.assignedComponentCodeFilter
            }
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.ServicingMAJCOM) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='ServicingMAJCOM'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.ServicingMAJCOM}
            name={DROP_DOWN_TITLES.ServicingMAJCOM}
            onChange={(e) => {
              onUpdateFilter(
                { servicingMAJCOMCodeFilter: e.value },
                filterOrder.ServicingMAJCOMCode
              )
              filterChangedOrder(e, filterOrder.ServicingMAJCOMCode)
            }}
            options={dropdownOptions.ServicingMAJCOMCode}
            value={
              dropdownOptions.ServicingMAJCOMCode?.length === 1
                ? dropdownOptions.ServicingMAJCOMCode[0].value
                : filter.servicingMAJCOMCodeFilter
            }
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.CurrentServicingUnit) &&
          INQUIRY_PAGES.includes(pageType) && (
            <CustomSelect
              className='form-sm w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
              id='Current Servicing Unit'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              label={DROP_DOWN_TITLES.CurrentServicingUnit}
              name={DROP_DOWN_TITLES.CurrentServicingUnit}
              onChange={(e) => {
                onUpdateFilter(
                  {
                    currentlyServicingByFilter: e.value,
                  },
                  filterOrder.CurrentlyServicingBy
                )
                filterChangedOrder(e, filterOrder.CurrentlyServicingBy)
              }}
              options={dropdownOptions.CurrentlyServicingBy}
              value={
                dropdownOptions.CurrentlyServicingBy?.length === 1
                  ? dropdownOptions.CurrentlyServicingBy[0].value
                  : filter.currentlyServicingByFilter
              }
            />
          )}
        {displayFilter(pageType, DROP_DOWN_TITLES.CurrentServicingUnit) &&
          !INQUIRY_PAGES.includes(pageType) && (
            <CustomSelect
              className='form-sm w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
              id='Current Servicing Unit'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              label={DROP_DOWN_TITLES.CurrentServicingUnit}
              name={DROP_DOWN_TITLES.CurrentServicingUnit}
              onChange={(e) => {
                onUpdateFilter(
                  {
                    servicingByFilter: e.value,
                  },
                  filterOrder.ServicingBy
                )
                filterChangedOrder(e, filterOrder.ServicingBy)
              }}
              options={dropdownOptions.ServicingBy}
              value={
                dropdownOptions.ServicingBy?.length === 1
                  ? dropdownOptions.ServicingBy[0].value
                  : filter.servicingByFilter
              }
            />
          )}
        {displayFilter(pageType, DROP_DOWN_TITLES.ServicingOrganization) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='ServicingOrganization'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.ServicingOrganization}
            name={DROP_DOWN_TITLES.ServicingOrganization}
            onChange={(e) => {
              onUpdateFilter(
                { servicingOrganizationFilter: e.value },
                filterOrder.ServicingOrganization
              )

              filterChangedOrder(e, filterOrder.ServicingOrganization)
            }}
            options={dropdownOptions.ServicingOrganization}
            value={
              dropdownOptions.ServicingOrganization?.length === 1
                ? dropdownOptions.ServicingOrganization[0].value
                : filter.servicingOrganizationFilter
            }
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.AssignedLocation) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='AssignedLocation'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.AssignedLocation}
            name={DROP_DOWN_TITLES.AssignedLocation}
            onChange={(e) => {
              onUpdateFilter({ assignedToLocationFilter: e.value }, filterOrder.Installation)

              filterChangedOrder(e, filterOrder.Installation)
            }}
            options={dropdownOptions.Installation}
            value={
              dropdownOptions.Installation?.length === 1
                ? dropdownOptions.Installation[0].value
                : filter.assignedToLocationFilter
            }
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.Organization) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Organization'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.Organization}
            name={DROP_DOWN_TITLES.Organization}
            onChange={(e) => {
              onUpdateFilter({ organizationFilter: e.value }, filterOrder.Organization)

              filterChangedOrder(e, filterOrder.Organization)
            }}
            options={dropdownOptions.Organization}
            value={
              dropdownOptions.Organization?.length === 1
                ? dropdownOptions.Organization[0].value
                : filter.organizationFilter
            }
          />
        )}

        {displayFilter(pageType, DROP_DOWN_TITLES.Section) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Section'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.Section}
            name={DROP_DOWN_TITLES.Section}
            onChange={(e) => {
              onUpdateFilter(
                {
                  sectionCodeFilter: e.value,
                },
                filterOrder.SectionCode
              )
              filterChangedOrder(e, filterOrder.SectionCode)
            }}
            options={dropdownOptions.SectionCode}
            value={
              dropdownOptions.SectionCode?.length === 1
                ? dropdownOptions.SectionCode[0].value
                : filter.sectionCodeFilter
            }
          />
        )}

        {displayFilter(pageType, DROP_DOWN_TITLES.Category) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Category'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.Category}
            name={DROP_DOWN_TITLES.Category}
            onChange={(e) => {
              onUpdateFilter(
                {
                  categoryCodeFilter: e.value,
                },
                filterOrder.CategoryCode
              )
              filterChangedOrder(e, filterOrder.CategoryCode)
            }}
            options={dropdownOptions.CategoryCode}
            value={
              dropdownOptions.CategoryCode?.length === 1
                ? dropdownOptions.CategoryCode[0].value
                : filter.categoryCodeFilter
            }
          />
        )}

        {displayFilter(pageType, DROP_DOWN_TITLES.SubCategory) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='SubCategory'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.SubCategory}
            name={DROP_DOWN_TITLES.SubCategory}
            onChange={(e) => {
              onUpdateFilter(
                {
                  subCategoryCodeFilter: e.value,
                },
                filterOrder.SubCategoryCode
              )
              filterChangedOrder(e, filterOrder.SubCategoryCode)
            }}
            options={dropdownOptions.SubCategoryCode}
            value={
              dropdownOptions.SubCategoryCode?.length === 1
                ? dropdownOptions.SubCategoryCode[0].value
                : filter.subCategoryCodeFilter
            }
          />
        )}

        {displayFilter(pageType, DROP_DOWN_TITLES.AssignedtoUsers) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='AssignedtoUsers'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.AssignedtoUsers}
            name={DROP_DOWN_TITLES.AssignedtoUsers}
            onChange={(e) => {
              onUpdateFilter(
                {
                  assignedToUsersFilter: e.value,
                },
                100
              )
              filterChangedOrder(e, 100)
            }}
            options={dropdownOptions.AssignedUser}
            value={filter.assignedToUsersFilter}
          />
        )}
        {displayFilter(pageType, 'Resolved/Closed Date') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Resolved/Closed Date'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='Resolved/Closed Date'
            name='Resolved/Closed Date'
            onChange={(e) => {
              onUpdateFilter({ resolvedClosedDateFilter: e.value }, filterOrder.NotCascading)
            }}
            options={ResolvedClosed}
            value={filter.resolvedClosedDateFilter}
          />
        )}
        {displayFilter(pageType, 'Closed') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Closed'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='Closed'
            name='Closed'
            onChange={(e) => {
              onUpdateFilter({ closedFilter: e.value }, filterOrder.NotCascading)
            }}
            options={Closed}
            value={filter.closedFilter}
          />
        )}
        {displayFilter(pageType, 'RNLTD') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='RNLTD'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='RNLTD'
            name='RNLTD'
            onChange={(e) => {
              onUpdateFilter({ dueOutRNLTDFilter: e.value }, filterOrder.NotCascading)
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={rnltdOptions}
            value={filter.dueOutRNLTDFilter}
          />
        )}
        {displayFilter(pageType, 'PDD') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='PDD'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='PDD'
            name='PDD'
            onChange={(e) => {
              onUpdateFilter({ dueOutPDDFilter: e.value }, filterOrder.NotCascading)
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={rnltdOptions}
            value={filter.dueOutPDDFilter}
          />
        )}
        {displayFilter(pageType, 'DOS') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='DOS'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='DOS'
            name='DOS'
            onChange={(e) => {
              onUpdateFilter({ dueOutDOSFilter: e.value }, filterOrder.NotCascading)
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={rnltdOptions}
            value={filter.dueOutDOSFilter}
          />
        )}
        {displayFilter(pageType, 'PRP') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='PRP'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='PRP'
            name='PRP'
            onChange={(e) => {
              onUpdateFilter({ dueOutPRPFilter: e.value }, filterOrder.NotCascading)
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={DueOutPRP}
            value={filter.dueOutPRPFilter}
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.Priority) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Priority'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.Priority}
            name={DROP_DOWN_TITLES.Priority}
            onChange={(e) => {
              onUpdateFilter(
                {
                  priorityFilter: e.value,
                },
                filterOrder.NotCascading
              )
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={DueOutPriority}
            value={filter?.priorityFilter}
          />
        )}
        {displayFilter(pageType, 'Due Date') && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical  poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='DueDate'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label='Due Date'
            name='Due Date'
            onChange={(e) => {
              onUpdateFilter({ dueOutDueDateFilter: e.value }, filterOrder.NotCascading)
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={rnltdOptions}
            value={filter.dueOutDueDateFilter}
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.Submitted) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='Submitted'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.Submitted}
            name={DROP_DOWN_TITLES.Submitted}
            onChange={(e) => {
              onUpdateFilter(
                {
                  submittedFilter: e.value,
                },
                filterOrder.NotCascading
              )
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={Submitted}
            value={filter.submittedFilter}
          />
        )}
        {displayFilter(pageType, DROP_DOWN_TITLES.ArchivedDate) && (
          <CustomSelect
            className='form-sm w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical poppins-semibold font-12 title-color2 col-sm-12 col-md-3 col-lg-6'
            id='ArchivedDate'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            label={DROP_DOWN_TITLES.ArchivedDate}
            name={DROP_DOWN_TITLES.ArchivedDate}
            onChange={(e) => {
              onUpdateFilter(
                {
                  archivedFilter: e.value,
                },
                filterOrder.NotCascading
              )
              filterChangedOrder(e, filterOrder.NotCascading)
            }}
            options={Submitted}
            value={filter.archivedFilter}
          />
        )}
      </div>
    </>
  )
}
export default Filters
